import { useEffect, useRef } from 'react';
import { trackEvent } from '../lib/trackEvent';

interface PageTimeTrackingOptions {
  pageKind: string;
  page: number;
}

export const usePageTimeTracking = ({ pageKind, page }: PageTimeTrackingOptions) => {
  const startTimeRef = useRef<number>(Date.now());

  useEffect(() => {
    const handleOnUnMount = () => {
      const endTime = Date.now();
      const totalTimeSpentSeconds = Math.floor((endTime - startTimeRef.current) / 1000);

      trackEvent('time_spent_on_page_in_seconds', {
        time_duration_on_page_sec: totalTimeSpentSeconds,
        page_kind: pageKind,
        page: page
      });
    };
    
    /*
    This may not work reliablly when a user closes the tab or refreshes the page.
    We can revisit this in future - using navigator.beacon to send metrics to posthog.
    */
    return () => {
      handleOnUnMount();
    };
  }, []);
};
